// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zWq4S","col":"styles_col__ZzCMh","actions":"styles_actions__d9EqD","conflict":"styles_conflict__29dfq"};